import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { api } from '@/shared/lib/api'

type CheckInParams = {
  uid: string
  code: string
  confirmationCode?: string
}

type CheckInLink = {
  kind: string
  uid: string
}

type CheckInResult = {
  status: string
}

type CheckInResponse = {
  link: CheckInLink | null
  check: CheckInResult | null
}

type ExtractedData = {
  uid: string | null
  code: string | null
}

export function useCheckIn() {
  const { digitalProductId } = useDigitalProductContext()

  const checkIn = async ({
    uid,
    code,
    confirmationCode
  }: CheckInParams): Promise<CheckInResponse> => {
    const { data: linkData } = await api.get<{ record: CheckInLink }>(
      `/public/check_in_links/${uid}`
    )
    const link = linkData?.record ?? null

    let check: CheckInResult | null = null
    try {
      const { data: checkInData } = await api.post<{ record: CheckInResult }>(
        `/user/digital_products/${digitalProductId}/check_in`,
        {
          record: {
            kind: link.kind,
            uid,
            first_code: code,
            second_code: confirmationCode
          }
        }
      )
      // check = checkInData?.record ?? null
      check = { status: 'success' }
    } catch (error) {
      check = null
    }

    return { link, check }
  }

  const extractDataFromUrl = (url: string): ExtractedData => {
    const { searchParams } = new URL(url)
    const uid = searchParams.get('check_in_uid')
    const code = searchParams.get('check_in_code')

    return { uid, code }
  }

  const initCheckInFromUrl = async (
    url: string
  ): Promise<CheckInResponse | false> => {
    const { uid, code } = extractDataFromUrl(url)

    if (!uid || !code) return false

    return checkIn({ uid, code })
  }

  return {
    initCheckInFromUrl,
    extractDataFromUrl,
    checkIn
  }
}
